import { Route, Routes, useLocation } from "react-router-dom";
import Home from './pages/Home';
import Login from './pages/Login';
import Admin from "./pages/Admin";
import Profile from './pages/Profile';
import Navbar from "./Components/navbar";
import { useEffect, useState } from "react";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Footer from "./Components/footer";
import BlogPage from "./pages/BlogPage"; 
import './App.css'; 
// import DarkMode from "./Components/DarkMode/DarkMode";
import ProjectDetail from "./pages/ProjectDetail";
import Projects from "./pages/ViewProject";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "./firebase";
import { collection, getDocs, query, where } from "firebase/firestore";

function App() {
  const [isAuth, setIsAuth] = useState(false);
  const[isAdmin, setIsAdmin] = useState(false);
  const location = useLocation();

  const shouldShowFooter = !location.pathname.startsWith('/blogs/');

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setIsAuth(false);
        setIsAdmin(false);
        return;
      }

      setIsAuth(true);

      try {
        const userQuery = query(collection(db, "users"), where("uid", "==", user.uid));
        const querySnapshot = await getDocs(userQuery);
        if (!querySnapshot.empty) {
          setIsAdmin(Boolean(querySnapshot.docs[0].data().isAdmin));
        } else {
          setIsAdmin(false);
        }
      } catch (error) {
        console.error("Error checking admin role:", error);
        setIsAdmin(false);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <>
      <Navbar isAuth={isAuth} setIsAuth={setIsAuth} isAdmin={isAdmin} setIsAdmin={setIsAdmin} />
      <div className="content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/login" element={<Login setIsAuth={setIsAuth} setIsAdmin={setIsAdmin} />} />
          <Route path="/admin" element={isAdmin?<Admin />:<Home/>} />
           <Route path="/projects" element={<Projects />} />
        <Route path="/project/:id" element={<ProjectDetail />} />
          <Route path="/blogs/:blogId" element={<BlogPage isAuth={isAuth} />} /> {/* Updated route */}
        </Routes>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        theme="colored"
        hideProgressBar={true}
        closeOnClick={true}
      />
      {shouldShowFooter && <Footer className="footer" />}
    </>
  );
}

export default App;
